module.exports = __webpack_public_path__ + "img/Foto 2.8d3a6891.png";